import { transformApiResponseData } from '@api/utilities/api_case';

import type { SurveyGPT, SurveyGPTResponse } from '../types';

export const transformSurveyGPT = ({
  active: isActive,
  ...data
}: SurveyGPTResponse): SurveyGPT => ({
  ...transformApiResponseData(data),
  isActive,
});
